import FetchInterceptor from "configs/FetchInterceptor";

class RewardGoodsServices {
  static async getAll(requestBody) {
    const apiUrl = "/core/v1/reward/goods/get/all";
    const response = await FetchInterceptor.post(apiUrl, requestBody);
    return response;
  }

  static async getById(id) {
    const apiUrl = `/core/v1/reward/goods/get/${id}`;
    const response = await FetchInterceptor.get(apiUrl);
    return response;
  }

  static async add(requestBody) {
    const apiUrl = "/core/v1/reward/goods/add";
    const response = await FetchInterceptor.post(apiUrl, requestBody);
    return response;
  }

  static async update(requestBody) {
    const apiUrl = "/core/v1/reward/goods/update";
    const response = await FetchInterceptor.post(apiUrl, requestBody);
    return response;
  }
}

export default RewardGoodsServices;
